import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormGroup, Validators } from '@angular/forms'
import { MatTableDataSource } from '@angular/material/table'
import { TableQuestion, TableRow } from '@mmx/shared'
import { cloneDeep, isNil, isPlainObject } from 'lodash'

@Component({
  selector: 'mmx-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  standalone: false,
})
export class TableComponent implements OnInit {
  @Input() question: TableQuestion
  @Input() form: UntypedFormGroup

  tableDisplayedColumns: any
  tableSource: MatTableDataSource<TableRow>
  formGroup: UntypedFormGroup

  ngOnInit() {
    this.tableDisplayedColumns = cloneDeep(this.question.columns)
    this.tableDisplayedColumns.push('actions')
    this.formGroup = this.form.controls['value'] as UntypedFormGroup

    if (isNil(this.question.value)) {
      this.question.value = []
    } else if (isPlainObject(this.question.value)) {
      this.question.value = [this.question.value as any]
    }

    this.tableSource = new MatTableDataSource(this.question.value)

    this.checkValidation()
  }

  addToTable() {
    // Required to fill out all fields to add new row
    if (
      Object.keys(this.form.value.value).length ===
      Object.values(this.form.value.value).filter(
        (x) => !(x == null || x === ''),
      ).length
    ) {
      this.question.value.push(this.form.value.value)
      this.tableSource = new MatTableDataSource(this.question.value)
      this.formGroup.reset()
      this.checkValidation()
    }
  }

  onDeleteItem(index: number) {
    this.question.value.splice(index, 1)
    this.tableSource = new MatTableDataSource(this.question.value)
    this.checkValidation()
  }

  private checkValidation() {
    if (this.question.required) {
      // If it is required but table is not empty, we can skip required validation
      this.formGroup.setValidators([Validators.required])
      for (const option of this.question.columns) {
        if (option) {
          if (this.question.required && this.question.value.length > 0) {
            this.formGroup.controls[option].clearValidators()
          } else {
            this.formGroup.controls[option].setValidators(
              this.question.getValidators(),
            )
          }
          // Update the FormGroup
          this.formGroup.controls[option].updateValueAndValidity()
        }
      }
    }
  }
}
